import { FC, ReactElement } from 'react';
import { useLocation } from 'react-router-dom';

import logo from '../../../assets/icons/header/checkout/logo.svg';
import secure from '../../../assets/icons/header/checkout/secure.svg';

const Transaction: FC = (): ReactElement | null => {
    const location = useLocation();
    const path = location.pathname;

    // Check if path matches pattern /:eventKey/page
    // We want to show header for cart, checkout, payment, payment-success
    // e.g. /event-123/cart

    // Regex for: /<something>/cart or checkout or payment...
    // matches /foo/cart, /foo/checkout, etc.
    const isVisible = /\/[^/]+\/(cart|checkout|payment|payment-success|invoice-confirmation|order)(\/|$)/.test(path);
    if (!isVisible) return null;

    const isSuccessPage = /\/[^/]+\/(payment-success|invoice-confirmation|order)/.test(path);
    const isCartPage = /\/[^/]+\/cart/.test(path);

    // Determine the secure text based on the page
    const getSecureText = (): string => {
        if (isCartPage) return 'Secure basket';
        return 'Secure checkout';
    };

    return (
        <div className="w-full h-[80px] bg-white border-b border-[#D0D5DD] flex items-center px-[20px] min-[576px]:px-[24px]">
            <div className="w-full max-w-[350px] min-[576px]:max-w-[1240px] mx-auto flex items-center justify-between">
                <div className="checkout-logo">
                    <img src={logo} alt="Informa Logo" style={{ width: '101px', height: '32px' }} />
                </div>

                {!isSuccessPage && (
                    <div className="flex items-center justify-end gap-[4px] text-[#00003c] font-semibold text-sm w-[122px] whitespace-nowrap">
                        <img src={secure} alt="Secure" style={{ width: '20px', height: '20px' }} />
                        <span>{getSecureText()}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Transaction;
